module.exports = __webpack_public_path__ + "static/img/preview-04.4a387806.webp";